import FormularioCuentas from "components/cuentas/FormularioCuentas";
import Navbar from "components/generales/Navbar";
import React from "react";
import "components/generales/Styles.css";
import "components/cuentas/StylesCuentas.css";

const RegistroCuentas = ({ cuenta }) => {
  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenCuentas"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>{cuenta?.nombre ? "Editar Cuenta" : "Registrar Cuenta"}</h2>
            <FormularioCuentas cuenta={cuenta} />
          </div>
        </div>
      </section>
    </>
  );
};

export default RegistroCuentas;
